import React from 'react';
import Script from 'next/script';

interface HubspotFormProps {
  portalId: string;
  formId: string;
  region: string;
  src?: string;
  targetId?: string;
  className?: string;
  locale?: string;
  onFormSubmitError?: (error: { message?: string; [key: string]: unknown }) => void;
  onFormReady?: (form: HTMLFormElement) => void;
}

export default function HubspotForm ({ 
  portalId, 
  formId, 
  region, 
  src, 
  targetId, 
  className, 
  locale,
  onFormSubmitError,
  onFormReady,
}: HubspotFormProps) {
  targetId ??= `hubspot-form-${formId}`;

  return (
    <>
      <div id={targetId} className={className} data-region={region} data-form-id={formId} data-portal-id={portalId} />
      <Script
        src={src || '//js.hsforms.net/forms/embed/v2.js'}
        strategy="afterInteractive"
        onLoad={() => {
          if (window.hbspt) {
            window.hbspt.forms.create({
              portalId,
              formId,
              region,
              target: `#${targetId}`,
              locale,
              onFormReady: (form: HTMLFormElement) => {
                // Call custom onFormReady callback if provided
                if (onFormReady) {
                  try {
                    onFormReady(form);
                  } catch (error) {
                    console.error('[HubspotForm] Error in onFormReady callback:', error);
                  }
                }
                
                // Listen for validation errors
                if (onFormSubmitError) {
                  form.addEventListener('submit', () => {
                    // Check if form is invalid
                    const isValid = form.checkValidity();
                    if (!isValid) {
                      try {
                        onFormSubmitError({ message: 'Form validation failed' });
                      } catch (error) {
                        console.error('[HubspotForm] Error in onFormSubmitError callback:', error);
                      }
                    }
                  });
                }
              },
            });
          }
        }}
      />
    </>
  );
}
